export default {
    SET_REQUESTS: (state, requests) => {
        state.requests = requests
    },

    SET_PAGINATION: (state, pagination) => {
        state.pagination = pagination
    },

    SET_LOAD: (state, isLoaded) => {
        state.isLoaded = isLoaded
    },

    SET_FILTERS: (state, filters) => {
        state.filters = filters
    },

    RESET_REQUESTS: (state) => {
        state.filters = {
            status: null,
            type: null,
            email: null
        }
    },

    UPDATE_STATUS: (state, data) => {
        const { index, old, status, oldStatus } = data

        if (old) {
            state.requests[index].oldStatus = status
        } else {
            state.requests[index].status = oldStatus
        }
    },

    SET_RESET_ACCOUNT_FEE_DATE: (state, data) => {
        state.resetAccountFeeDate = data
    }
}
